import styled from 'styled-components';
import C from '@assets/themes/colors'

export const Root = styled.div`
  margin-top: 20px;
  margin-left: 50px;
  margin-right: 78px;
  min-height: 420px;
  min-width: 350px;
  max-width: 100%;
  border-radius: 5px;
  background-color: #e5e5e5;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`

export const RenderBox = styled.div`
  display: flex;
`

export const EmptyTitle = styled.div`
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #b0aeae;
`

export const Grid = styled.div`
  flex: 1;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
`

export const GridItemContainer = styled.div`
  padding: 10px;
`

export const GridTitle = styled.div`
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  padding: 0px 0px 5px 0px;
  color: ${C.DARKER_GRAY};
`

export const GridItem = styled.img`
  object-fit: contain;
`